import React, { Component } from 'react';
import { TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { get, take } from 'global/lib/lodash';
import { InView } from 'react-intersection-observer';
import { CenterLoader } from '../../styles';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,

  ...(isDragging && {
    background: 'rgb(235,235,235)',
  }),
});

export default class DndTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.items,
      take: props.take || 10,
      takeAmt: props.takeAmt || 10,
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(this.state.items, result.source.index, result.destination.index);

    this.setState(
      {
        items,
      },
      () => {
        this.props.onOrderChange && this.props.onOrderChange(items);
      }
    );
  }

  onSelectRow = (item, e) => {
    this.props.onSelectRow && this.props.onSelectRow(item, e);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.items !== this.props.items) {
      this.setState({ items: this.props.items });
    }
  }

  renderRow = (item, index) => {
    const { columns } = this.props;
    const canDrag = get(this, 'props.canDrag', true);

    return (
      <TableRow component={canDrag ? DraggableComponent(item.id, index) : undefined} onClick={(e) => this.onSelectRow(item, e)} key={item.id}>
        {this.props.renderRow
          ? this.props.renderRow(item)
          : columns.map((col) => {
              const val = col.render ? col.render(item, get(item, col.field)) : get(item, col.field);
              return (
                <TableCell key={col.field} width={col.width}>
                  {val}
                </TableCell>
              );
            })}
      </TableRow>
    );
  };

  render() {
    const { columns } = this.props;

    const showHeader = get(this, 'props.showHeader', true);
    const showBody = get(this, 'props.showBody', true);

    return (
      <TableContainer component={Paper}>
        <Table>
          {showHeader && (
            <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <TableCell key={col.field} width={col.width}>
                    {col.title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          )}
          {showBody && <TableBody component={DroppableComponent(this.onDragEnd)}>{take(this.state.items, this.state.take).map(this.renderRow)}</TableBody>}
        </Table>
        {this.state.items.length >= this.state.take && (
          <InView onChange={(inView, entry) => this.setState({ take: this.state.take + this.state.takeAmt })}>
            <CenterLoader style={{ overflow: 'hidden' }} />
          </InView>
        )}
      </TableContainer>
    );
  }
}

const DraggableComponent = (id, index) => (props) => {
  return (
    <Draggable draggableId={id} index={index}>
      {(provided, snapshot) => (
        <TableRow ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)} {...props}>
          {props.children}
        </TableRow>
      )}
    </Draggable>
  );
};

const DroppableComponent = (onDragEnd) => (props) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={'1'} direction="vertical">
        {(provided) => {
          return (
            <TableBody ref={provided.innerRef} {...provided.droppableProps} {...props}>
              {props.children}
              {provided.placeholder}
            </TableBody>
          );
        }}
      </Droppable>
    </DragDropContext>
  );
};
